import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view06ImageOptions } from './views/exterior_view06'

class XP55Wheel extends Component {
    constructor(props) {
        super(props);
        this.handleWheelChange = this.handleWheelChange.bind(this);
    }
    
    handleWheelChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Wheel = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view06ImageOptions;

        let image = <ConfiguratorImage boat="XP55" configuration={this.props.configuration} options={imageOptions} />;

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Wheels' /></h1>
                    <p><Trans defaults='The electronic equipment shown on this render is optional. Please contact your local dealer for further information.' /></p>
                    <p><Trans defaults='The wheel instrument platform is optional as well as the instruments.' /></p>
                    <RadioGroup label={this.props.t("Options:")} options={this.props.wheelOptions} value={this.props.configuration.Wheel} onChange={this.handleWheelChange} />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XP55Wheel);


// WEBPACK FOOTER //
// ./src/XP55/XP55Wheel.js